<template>
    <div>
        <div v-if="item && item.isas_error" class="ml-2 mb-2 pl-3">
            <p class="info--text mb-0">
                <strong>{{ $t('Ошибки при обработке') }}:</strong>
            </p>
            <span>{{ item.isas_error }}</span>
        </div>
        <div style="max-width: 600px" v-if="item" :class="{ 'pt-2 pr-2': $vuetify.breakpoint.xsOnly }">
            <p class="info--text ml-3 mb-1">
                <strong class="ml-3">{{ $t('ПУТЭ в файле') }}:</strong>
            </p>
            <v-data-table class="ml-2 mt-0 mb-2 " :headers="metersTableHeaders" :items="metersList" disable-sort hide-default-footer>
                <template v-slot:item.meter_rid="{ item }">
                    <table-cell-tooltip :header="metersTableHeaders[0]" :item="item">
                        <span>{{ item.meter_rid }}</span>
                    </table-cell-tooltip>
                </template>
                <template v-slot:item.meter_number="{ item }">
                    <table-cell-tooltip :header="metersTableHeaders[1]" :item="item">
                        <span>{{ item.meter_number }}</span>
                    </table-cell-tooltip>
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import TableCellTooltip from '@/components/ui/TableCellTooltip';

export default {
    props: ['item'],
    components: {
        TableCellTooltip
    },
    data: () => ({
        tab: 0,
        metersList: []
    }),
    watch: {
        item: async function() {
            this.metersList = await this.getFileMeters(this.item.record_id);
        }
    },
    async created() {
        this.metersList = await this.getFileMeters(this.item.record_id);
    },
    computed: {
        tabs() {
            let tabs = [
                { tab: this.$t('Ошибки при обработке'), show: this.item.isas_error ? true : false, content: 'Основная информация текст' },
                { tab: this.$t('ПУТЭ в файле'), show: true, content: 'Платежи текст' }
            ];
            return tabs.filter(item => item.show === true);
        },
        errorsTableHeaders() {
            return [];
        },
        metersTableHeaders() {
            return [
                { text: this.$t('ID номер ПУТЭ'), value: 'meter_rid', divider: true },
                { text: this.$t('Заводской номер'), value: 'meter_number' }
            ];
        }
    },
    methods: {
        ...mapActions('uploads', ['getFileMeters'])
    }
};
</script>

<style></style>
